'use client';

import { useEffect } from 'react';
import type { AuctionDetailsResponse } from '../../services/generated/Api';
import { AUCTION_UPDATE_INTERVAL } from './constants';

interface UsePeriodicUpdateOptions {
  auction: AuctionDetailsResponse | null;
  localTimeRemaining: number;
  onUpdate: () => void;
}

export const usePeriodicUpdate = ({
  auction,
  localTimeRemaining,
  onUpdate,
}: UsePeriodicUpdateOptions): void => {
  // Use stable primitive for dependency
  const auctionId = auction?.id;

  useEffect(() => {
    if (!auctionId || localTimeRemaining <= 0) return;

    const interval = setInterval(() => {
      onUpdate();
    }, AUCTION_UPDATE_INTERVAL);

    return () => clearInterval(interval);
  }, [auctionId, localTimeRemaining, onUpdate]);
};
